var exports = {
  "GB": "RadioGroup_Label__N9z-VI",
  "LV": "Dialog_Footer__-RVB0J",
  "b1": "branchNameContainer__lhk_B8",
  "bk": "fieldLabel__w--jmY",
  "ks": "TextInput__P3PW87",
  "$I": "repositoryBranchRow__k_0p3X",
  "aT": "repositoryPickerContainer__4qTEdx",
  "YW": "repositoryPickerHeader__5wRfjP",
  "xX": "branchSourceContainer__yKI5rW",
  "lq": "loadingRepositoryBranchRow__rp--Dj",
  "v9": "loadingBranchSourceContainer__wuj2Bb",
};

module.exports = exports;
